import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import MailAddressGenerator from './mailaddressgenerator';

const Tools = () => {
  const [showMailGenerator, setShowMailGenerator] = useState(false);

  return (
    <Container className="mt-4">
      <h2>Tools</h2>
      <div>
        <Button 
          variant="primary" 
          onClick={() => setShowMailGenerator(true)}
          className="mb-3"
        >
          E-Mail-Adress-Generator
        </Button>
      </div>

      <MailAddressGenerator 
        show={showMailGenerator} 
        onHide={() => setShowMailGenerator(false)} 
      />
    </Container>
  );
};

export default Tools;
